(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1858],{

/***/ 31858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Content051": function() { return /* binding */ Content051; },
  "default": function() { return /* binding */ Content051_Content051; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/shared/components/index.js + 114 modules
var components = __webpack_require__(47696);
// EXTERNAL MODULE: ./src/shared/components/LazyRenderingButton/index.js + 3 modules
var LazyRenderingButton = __webpack_require__(41141);
// EXTERNAL MODULE: ./src/components/widgets/content/Content051/Content051.module.scss
var Content051_module = __webpack_require__(34809);
var Content051_module_default = /*#__PURE__*/__webpack_require__.n(Content051_module);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/shared/contexts/ViewMode/index.js + 5 modules
var ViewMode = __webpack_require__(32667);
// EXTERNAL MODULE: ./src/components/widgets/content/Content051/Items/Items.module.scss
var Items_module = __webpack_require__(60149);
var Items_module_default = /*#__PURE__*/__webpack_require__.n(Items_module);
;// CONCATENATED MODULE: ./src/components/widgets/content/Content051/Items/Items.jsx







var Items = function(param) {
    var items = param.items;
    var isDesktop = (0,ViewMode/* useViewMode */.mJ)().isDesktop;
    var limit = (0,LazyRenderingButton/* useLazyRenderingState */.vO)().limit;
    var gridSize = isDesktop ? 4 : 2;
    var slicedItems = (0,react.useMemo)(function() {
        return items.slice(0, limit);
    }, [
        limit,
        items
    ]);
    var groupedItems = (0,react.useMemo)(function() {
        var source = (0,_to_consumable_array/* default */.Z)(slicedItems);
        var result = [];
        var index = 0;
        while(source.length > 0){
            result.push({
                key: "group_".concat(index++),
                items: source.splice(0, gridSize)
            });
        }
        return result;
    }, [
        gridSize,
        slicedItems
    ]);
    var style = (0,react.useMemo)(function() {
        return {
            gridTemplateColumns: "repeat(".concat(gridSize, ", 1fr)")
        };
    }, [
        gridSize
    ]);
    return groupedItems.map(function(group) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (Items_module_default()).row,
            style: style,
            children: group.items.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Items_module_default()).item,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ImageLite */.NH, {
                            image: item.logo,
                            className: (Items_module_default()).image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Paragraph */.nv, {
                            color: "grey",
                            className: (Items_module_default()).title,
                            appearance: "bigger",
                            children: item.title
                        })
                    ]
                }, item.id);
            })
        }, group.key);
    });
};

;// CONCATENATED MODULE: ./src/components/widgets/content/Content051/Items/index.js


;// CONCATENATED MODULE: ./src/components/widgets/content/Content051/Content051.jsx





var Content051 = function(param) {
    var payload = param.payload;
    var ref;
    var title = (ref = payload === null || payload === void 0 ? void 0 : payload.title) !== null && ref !== void 0 ? ref : "";
    var ref1;
    var partners = (ref1 = payload === null || payload === void 0 ? void 0 : payload.partners) !== null && ref1 !== void 0 ? ref1 : [];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Content051_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Content051_module_default()).block,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Heading3 */.aC, {
                        className: (Content051_module_default()).title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(LazyRenderingButton/* LazyRenderingProvider */.Bv, {
                        size: partners.length,
                        initialLimit: 8,
                        incrementBy: 8,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Items, {
                                items: partners
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* LazyRenderingButton */.WJ, {})
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Content051_Content051 = (Content051);


/***/ }),

/***/ 34809:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content051_wrapper__K4AoY","title":"Content051_title__t5Zsk"};

/***/ }),

/***/ 60149:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"row":"Items_row__7Vrir","item":"Items_item__JCWhJ","title":"Items_title__j1Bx3","image":"Items_image__wDukA"};

/***/ })

}]);